import {addDoc, collection, doc, getDoc, getDocs, query, setDoc, where, orderBy, deleteDoc} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import Promise from "bluebird";
import _ from "lodash";

export {
    addTags,
    addSingleTag,
    updateSingleTag,
    deleteSingleTag,
    getSingleTag,
    getSingleTagById,
    searchTags,
    getAllTags,
    prepareTagsList
}

const collectionName = 'tags';
const collectionReference = collection(fireStoreDB, collectionName);

const addTags = (tags) => {
    return Promise.map(tags, async tag => {
        await addSingleTag(tag);
    });
}

const addSingleTag = (tag) => {
    return addDoc(collectionReference, tag);
}

const updateSingleTag = (tag) => {
    const documentReference = doc(fireStoreDB, collectionName, tag.id);
    return setDoc(documentReference, tag);
}

const deleteSingleTag = (tag) => {
    const documentReference = doc(fireStoreDB, collectionName, tag.id);
    return deleteDoc(documentReference);
}

const getSingleTag = (tagId) => {
    const documentReference = doc(fireStoreDB, collectionName, tagId);
    return getDoc(documentReference);
}

const getSingleTagById = async (designId) => {
    const documentReference = doc(fireStoreDB, collectionName, designId);
    const designResult = await getDoc(documentReference);
    return prepareTagData(designResult);
}

const searchTags = async (searchText) => {
    let searchQuery = query(collectionReference, orderBy('text', 'asc'));

    if (searchText) {
        searchQuery = query(collectionReference,
            where("textList", "array-contains", searchText),
            orderBy('text', 'asc'),);
    }

    const tagResult = await getDocs(searchQuery);
    return prepareTagsList(tagResult);
}

const getAllTags = async () => {
    let searchQuery = query(collectionReference);

    const tagResult = await getDocs(searchQuery);
    return prepareTagsList(tagResult);
}

const prepareTagsList = (tagResult) => {
    const tagsList = [];

    _.forEach(tagResult.docs, tagDoc => {
        tagsList.push({
            ...tagDoc.data(),
            id: tagDoc.id
        });
    });

    return tagsList;
}

const prepareTagData = (designDoc) => {
    if (!designDoc.exists) {
        return null;
    }

    return {
        ...designDoc.data(),
        id: designDoc.id
    }
}
